/* eslint-disable */
import { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*------ Helper imports ------*/
import * as url from "helper/UrlHelper";
import { getData } from "utils/Gateway";
import { assetImages } from "constants";

const ProductTab = ({ tabName = "" }) => {
  const placeholderItemCount = 5;
  const { t } = useTranslation(); // translation marker
  const { id: companyId } = useParams(); // Renamed for clarity
  const token = localStorage.getItem("token");

  // State management
  const [isLoading, setIsLoading] = useState(true);
  const [serviceProductList, setServiceProductList] = useState([]);
  const [featureProductList, setFeatureProductList] = useState([]);

  //function for get all products
  const getAllProducts = async () => {
    setIsLoading(true);
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_ALL_PRODUCTS +
        `?token=${token}&companies=${companyId}`;

      console.log("requestURL --------> ", requestURL);

      const response = await getData(requestURL);

      setIsLoading(false);

      if (response.status) {
        const serviceProducts = response.data.filter(
          (product) => product.isservicefeatured
        );
        const featureProducts = response.data.filter(
          (product) => product.isproductfeatured
        );
        setServiceProductList(serviceProducts);
        setFeatureProductList(featureProducts);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (companyId && tabName === "products") {
      getAllProducts();
    }
  }, [companyId, tabName]);

  if (isLoading) {
    return (
      <div className="people_detailspnl">
        {/* Services Placeholder */}
        <div className="people_details_bx white_shadow_bx">
          <div className="details_hdng">
            <h4 className="placeholder-glow">
              <span className="placeholder col-4"></span>
            </h4>
          </div>
          {[...Array(placeholderItemCount)].map((_, index) => (
            <div className="white_shadow_bx people_bx" key={index}>
              <div className="people_row">
                <div className="left_people d-flex">
                  <div className="people_profile me-3">
                    <span
                      className="placeholder rounded-circle"
                      style={{
                        width: "64px",
                        height: "64px",
                        display: "inline-block",
                      }}
                    ></span>
                  </div>
                  <div className="people_profile_info">
                    <h3 className="placeholder-glow mb-2">
                      <span className="placeholder col-6"></span>
                    </h3>
                    <h5 className="placeholder-glow mb-1">
                      <span className="placeholder col-3"></span>
                    </h5>
                  </div>
                </div>
                <div className="right_people_btn">
                  <span className="btn btn-outline-secondary disabled placeholder col-5"></span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Products Placeholder */}
        <div className="people_details_bx white_shadow_bx">
          <div className="details_hdng">
            <h4 className="placeholder-glow">
              <span className="placeholder col-4"></span>
            </h4>
          </div>
          {[...Array(placeholderItemCount)].map((_, index) => (
            <div className="white_shadow_bx people_bx" key={index}>
              <div className="people_row">
                <div className="left_people d-flex">
                  <div className="people_profile me-3">
                    <span
                      className="placeholder rounded-circle"
                      style={{
                        width: "64px",
                        height: "64px",
                        display: "inline-block",
                      }}
                    ></span>
                  </div>
                  <div className="people_profile_info">
                    <h3 className="placeholder-glow mb-2">
                      <span className="placeholder col-6"></span>
                    </h3>
                    <h5 className="placeholder-glow mb-1">
                      <span className="placeholder col-3"></span>
                    </h5>
                  </div>
                </div>
                <div className="right_people_btn">
                  <span className="btn btn-outline-secondary disabled placeholder col-5"></span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="people_detailspnl">
      <div className="people_details_bx white_shadow_bx">
        <div className="details_hdng">
          <h4>Services</h4>
        </div>
        {serviceProductList.map((product, index) => {
          return (
            <div className="white_shadow_bx people_bx" key={index}>
              <div className="people_row">
                <div className="left_people">
                  <div className="people_profile">
                    <img
                      width="64"
                      height="64"
                      className="rounded-circle"
                      src={url.SERVER_URL + product.productimagepath}
                      alt=""
                    />
                  </div>
                  <div className="people_profile_info">
                    <h3>{product.name}</h3>
                    <h5 className="mb-1">€ {product.price}</h5>
                  </div>
                </div>
                <div className="right_people_btn">
                  <Link
                    to={`/marketplace/details/${product._id}`}
                    className="btn outline"
                  >
                    {t("View Details")}
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="people_details_bx white_shadow_bx">
        <div className="details_hdng">
          <h4>Products</h4>
        </div>
        {featureProductList.map((product, index) => {
          return (
            <div className="white_shadow_bx people_bx" key={index}>
              <div className="people_row">
                <div className="left_people">
                  <div className="people_profile">
                    <img
                      width="64"
                      height="64"
                      className="rounded-circle"
                      src={url.SERVER_URL + product.productimagepath}
                      alt=""
                    />
                  </div>
                  <div className="people_profile_info">
                    <h3>{product.name}</h3>
                    <h5 className="mb-1">€ {product.price}</h5>
                  </div>
                </div>
                <div className="right_people_btn">
                  <Link
                    to={`/marketplace/details/${product._id}`}
                    className="btn outline"
                  >
                    {t("View Details")}
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductTab;
